import * as React from 'react';
import { Button } from '@mantine/core';
import classes from './WhatsAppButton.module.css';

import { ReactComponent as WhatsappLogo } from './../../imgs/whatsapp-logo.svg';

export function WhatsAppButton() {
  return (
    <Button
      role="link"
      aria-label="Contáctanos por WhatsApp"
      variant="filled"
      color="green"
      size="xl"
      radius="xl"
      className={classes.globalWhatsappButton}
      component="a"
      href="https://wa.me/8138924955"
      target="_blank"
      rel="noopener noreferrer"
    >
      <WhatsappLogo style={{ fill: 'white' }} className={classes.whatsAppIcon} />
    </Button>
  );
}
